import React, { createContext, useState } from 'react';
import axios from 'axios';

export const AudioContext = createContext();

export const AudioProvider = ({ children }) => {
  const [currentTrack, setCurrentTrack] = useState(null);
  const [autoPlay, setAutoPlay] = useState(false);
  const [currentSound, setCurrentSound] = useState(null);
  const [tracks, setTracks] = useState([]); // Store the track list
  const [currentTrackIndex, setCurrentTrackIndex] = useState(0);

  const playSound = async (newSound) => {
    if (currentSound && currentSound !== newSound) {
      const currentStatus = await currentSound.getStatusAsync();
      if (currentStatus.isLoaded) {
        await currentSound.stopAsync();
        await currentSound.unloadAsync();
      }
    }
    setCurrentSound(newSound);
  };

  const stopCurrentSound = async () => {
    if (currentSound) {
      const currentStatus = await currentSound.getStatusAsync();
      if (currentStatus.isLoaded) {
        await currentSound.stopAsync();
        await currentSound.unloadAsync();
        setCurrentSound(null);
      }
    }
  };

  const fetchAllUploads = async () => {
    try {
      const response = await axios.get('https://sync-api-troz.onrender.com/api/uploads/all-uploads');
      return response.data;
    } catch (error) {
      console.error('Error fetching all uploads:', error);
      return [];
    }
  };

  const handleTrackClick = async (track) => {
    const index = tracks.findIndex((t) => t._id === track._id);
    if (index === -1) {
      // Track not in current tracks array, reset to all uploads
      const allUploads = await fetchAllUploads();
      setTracks(allUploads);
      const newIndex = allUploads.findIndex((t) => t._id === track._id);
      setCurrentTrackIndex(newIndex !== -1 ? newIndex : 0);
    } else {
      setCurrentTrackIndex(index);
    }
    setCurrentTrack(track);
    setAutoPlay(true);
  };

  const playNextTrack = async () => {
    if (tracks.length > 0) {
      await stopCurrentSound();
      const nextIndex = (currentTrackIndex + 1) % tracks.length;
      setCurrentTrackIndex(nextIndex);
      setCurrentTrack(tracks[nextIndex]);
      setAutoPlay(true);
    }
  };

  const playPreviousTrack = async () => {
    if (tracks.length > 0) {
      await stopCurrentSound();
      const prevIndex = (currentTrackIndex - 1 + tracks.length) % tracks.length;
      setCurrentTrackIndex(prevIndex);
      setCurrentTrack(tracks[prevIndex]);
      setAutoPlay(true);
    }
  };

  const playAlbum = async (albumId) => {
    try {
      const response = await axios.get(`https://sync-api-troz.onrender.com/api/uploads/album-details/${albumId}`);
      const album = response.data;
      if (album && album.tracks.length > 0) {
        await stopCurrentSound();
        setTracks(album.tracks);
        setCurrentTrackIndex(0);
        setCurrentTrack(album.tracks[0]);
        setAutoPlay(true);
      }
    } catch (error) {
      console.error('Error loading album tracks:', error);
    }
  };

  return (
    <AudioContext.Provider
      value={{
        playSound,
        stopCurrentSound,
        handleTrackClick,
        playNextTrack,
        playPreviousTrack,
        playAlbum,
        currentTrack,
        autoPlay,
        tracks,
        setTracks,
      }}
    >
      {children}
    </AudioContext.Provider>
  );
};